import { httpGet, httpPost, httpPut } from "shared/api/apiHandler";
import urls from "shared/api/spaceStone/urls";
import BooleanResponseWithErrors from "shared/models/booleanResponseWithErrors";
import { BranchApiModel } from "app/spaceStone/companyDetails/companyBranches/models/branchModel";

export const verifyCompanyRegistrationNumber = async (
    companyRegistrationNumber: string
): Promise<BooleanResponseWithErrors> => {
    const data = { companyRegistrationNumber };

    const result = await httpPost<BooleanResponseWithErrors>(
        window.APP_SETTINGS.spaceStoneApiBaseUri,
        urls.AGENCY.VERIFY_REGISTRATION_NUMBER,
        data
    );

    return result.data;
};

export const getBranches = async (): Promise<BranchApiModel[]> => {
    const result = await httpGet<BranchApiModel[]>(window.APP_SETTINGS.spaceStoneApiBaseUri, urls.AGENCY.BRANCHES);
    return result.data as BranchApiModel[];
};

export const updateBranch = async (branch: { branch: BranchApiModel }): Promise<BranchApiModel> => {
    const result = await httpPut<BranchApiModel>(
        window.APP_SETTINGS.spaceStoneApiBaseUri,
        urls.AGENCY.BRANCHES,
        branch
    );
    return result.data as BranchApiModel;
};

export const createBranch = async (branch: { branch: BranchApiModel }): Promise<BranchApiModel> => {
    const result = await httpPost<BranchApiModel>(
        window.APP_SETTINGS.spaceStoneApiBaseUri,
        urls.AGENCY.BRANCHES,
        branch
    );
    return result.data as BranchApiModel;
};
